import getDefaultHeaders from '@americanexpress/iguazu-resources/utils/getDefaultHeaders';
import { getOneCMSInternetSSRApiUrl } from '../selectors/getBaseUrlSelectors';

export default {
  fetch: ({
    content,
    locale,
    taxonomy,
    directory,
  }, action, state) => ({
    url: `${getOneCMSInternetSSRApiUrl(state)}/Internet/travel/${directory ? `${directory}` : 'common'}/${locale.toLowerCase()}/${taxonomy ? `${taxonomy}/` : ''}${content}.json`,
    opts: {
      method: 'GET',
      credentials: 'omit',
      headers: {
        Accept: 'application/json',
      },
      ...getDefaultHeaders(),
    },
  }),
};
